import _Cancel from "@mui/icons-material/Cancel";
import React, { useEffect, useReducer, useState } from 'react';
import styled from 'styled-components';
import { ContentAdDesktop } from 'app/styles/content';
import { useDispatch, useSelector } from 'react-redux';
import { COLORS } from '@fupa/fupa-uikit';
import { Helmet } from 'react-helmet-async';
import { TITLE_POSTFIX } from 'app/seo/seo.constants';
import { useHistory, useLocation, useParams } from 'react-router';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { fetchRegions, fetchDistricts, setRegionSelectHeader } from 'app/routes/region/RegionSelectPageActions';
import { RegionSelectPageReducer } from 'app/routes/region/RegionSelectPageReducer';
import { useFetchData, useRestoreData } from 'app/hooks/dataHooks';
import { LastDistricts } from 'app/components/region/LastDistricts';
import RegionList from 'app/components/region/RegionList';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
const FilterWrapper = styled.div.withConfig({
  componentId: "sc-r8xqxx-0"
})(["padding:0.25rem 1rem;"]);
const RegionSelectPage = () => {
  var _selectedUserDistrict, _districts$regionSlug, _districts$regionSlug2, _defaultRegion$name;
  // Keep path of caller (specific district page, e.g. MatchCalendarDefaultPage) to switch district
  const {
    state: caller
  } = useLocation();
  const history = useHistory();
  const selectedUserDistrict = useSelector(reduxSelectDistrict);
  const {
    restoredData
  } = useRestoreData('RegionSelectPage');
  const {
    regionSlug
  } = useParams();
  const initialState = restoredData !== null && restoredData !== void 0 ? restoredData : {
    regions: {
      isFetching: false,
      items: []
    },
    districts: {}
  };
  const [state, dispatch] = useReducer(RegionSelectPageReducer, initialState);
  const dispatchRedux = useDispatch();
  const loadDistrictsByRegion = regionSlug => fetchDistricts(regionSlug)(dispatch, state);
  const loadData = () => {
    return Promise.all([fetchRegions(selectedUserDistrict, dispatchRedux)(dispatch, state), loadDistrictsByRegion(regionSlug)]);
  };
  const {
    regions: {
      items: regions
    },
    districts
  } = state;
  useFetchData(state, loadData, 'RegionSelectPage');
  const defaultRegion = (_selectedUserDistrict = selectedUserDistrict === null || selectedUserDistrict === void 0 ? void 0 : selectedUserDistrict.region) !== null && _selectedUserDistrict !== void 0 ? _selectedUserDistrict : null;
  const [openRegion, setOpenRegion] = useState(regionSlug);
  const defaultFilterValue = districts[regionSlug] ? (_districts$regionSlug = (_districts$regionSlug2 = districts[regionSlug].items) === null || _districts$regionSlug2 === void 0 || (_districts$regionSlug2 = _districts$regionSlug2[0]) === null || _districts$regionSlug2 === void 0 || (_districts$regionSlug2 = _districts$regionSlug2.region) === null || _districts$regionSlug2 === void 0 ? void 0 : _districts$regionSlug2.name) !== null && _districts$regionSlug !== void 0 ? _districts$regionSlug : '' : (_defaultRegion$name = defaultRegion === null || defaultRegion === void 0 ? void 0 : defaultRegion.name) !== null && _defaultRegion$name !== void 0 ? _defaultRegion$name : '';
  const [filterValue, setFilterValue] = useState(defaultFilterValue);
  useEffect(() => {
    if (regionSlug) {
      return;
    }
    if (!(selectedUserDistrict !== null && selectedUserDistrict !== void 0 && selectedUserDistrict.region)) {
      return;
    }
    history.replace({
      pathname: "/select/".concat(selectedUserDistrict.region.slug),
      state: caller
    });
    loadDistricts(selectedUserDistrict.region.slug);
  }, [selectedUserDistrict]);
  useEffect(() => {
    setRegionSelectHeader(dispatchRedux, selectedUserDistrict);
  }, [regionSlug]);
  useEffect(() => {
    if (openRegion === '') {
      history.replace({
        pathname: '/select',
        state: caller
      });
    }
  }, [openRegion]);
  const onFilterChange = event => {
    const value = event.target.value;
    setFilterValue(value);
  };
  const handleClear = () => {
    setFilterValue('');
  };
  const loadDistricts = regionSlug => {
    if (openRegion === regionSlug) {
      setOpenRegion('');
    } else {
      loadDistrictsByRegion(regionSlug);
      setOpenRegion(regionSlug);
    }
  };
  const canonical = regionSlug ? /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: "https://www.fupa.net/region/".concat(regionSlug)
  }) : null;
  const meta = [{
    name: 'robots',
    content: 'index'
  }];
  return /*#__PURE__*/React.createElement(ContentAdDesktop, {
    noTabs: true,
    top: "4.5rem",
    noAds: true,
    "data-sentry-element": "ContentAdDesktop",
    "data-sentry-component": "RegionSelectPage",
    "data-sentry-source-file": "RegionSelectPage.tsx"
  }, /*#__PURE__*/React.createElement(Helmet, {
    title: "Regionsauswahl".concat(TITLE_POSTFIX),
    meta: meta,
    "data-sentry-element": "Helmet",
    "data-sentry-source-file": "RegionSelectPage.tsx"
  }, canonical), /*#__PURE__*/React.createElement(LastDistricts, {
    selectedDistrict: selectedUserDistrict,
    "data-sentry-element": "LastDistricts",
    "data-sentry-source-file": "RegionSelectPage.tsx"
  }), /*#__PURE__*/React.createElement(FilterWrapper, {
    "data-sentry-element": "FilterWrapper",
    "data-sentry-source-file": "RegionSelectPage.tsx"
  }, /*#__PURE__*/React.createElement(TextField, {
    autoFocus: true,
    color: "secondary",
    variant: 'standard',
    fullWidth: true,
    id: "filterregions",
    label: "Filter Regionen",
    name: "filterregions",
    autoComplete: "off",
    onChange: onFilterChange,
    value: filterValue,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        tabIndex: 1,
        "aria-label": "Textfeld zur\xFCcksetzen",
        onClick: handleClear,
        size: "large"
      }, /*#__PURE__*/React.createElement(_Cancel, {
        style: {
          color: COLORS.darkGrey,
          fontSize: 24
        }
      })))
    },
    "data-sentry-element": "TextField",
    "data-sentry-source-file": "RegionSelectPage.tsx"
  })), /*#__PURE__*/React.createElement(RegionList, {
    regions: regions,
    filterValue: filterValue,
    openRegion: openRegion,
    districts: districts,
    loadDistricts: loadDistricts,
    "data-sentry-element": "RegionList",
    "data-sentry-source-file": "RegionSelectPage.tsx"
  }));
};
export default RegionSelectPage;